import { render, staticRenderFns } from "./CoursePageWrapper.vue?vue&type=template&id=6e3fd862&"
import script from "./CoursePageWrapper.vue?vue&type=script&lang=ts&"
export * from "./CoursePageWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6e3fd862', component.options)
    } else {
      api.reload('6e3fd862', component.options)
    }
    module.hot.accept("./CoursePageWrapper.vue?vue&type=template&id=6e3fd862&", function () {
      api.rerender('6e3fd862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePageWrapper.vue"
export default component.exports